import { render, staticRenderFns } from "./NoteLogger.vue?vue&type=template&id=2404c1e3&scoped=true"
import script from "./NoteLogger.vue?vue&type=script&lang=ts"
export * from "./NoteLogger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404c1e3",
  null
  
)

export default component.exports